export default function (identifier) {
    return JSON.parse(sessionStorage.getItem(identifier))
}
